module.exports = __webpack_public_path__ + "img/tiyoutr.a582ecd4.png";